import { tw } from "@careinfo/tailwind";
import { File } from "lucide-react";
import React from "react";

const isUrl = (text) => {
  try {
    new URL(text);
    return true;
  } catch (_) {
    return false;
  }
};

const isFileUrl = (url) => {
  const fileExtensions = ["jpg", "jpeg", "png", "gif", "pdf", "docx", "xlsx"];
  const cleanUrl = url.split("?")[0];
  const ext = cleanUrl.split(".").pop().toLowerCase();
  return fileExtensions.includes(ext);
};

const getFileNameFromUrl = (url: string): string => {
  try {
    const pathname = new URL(url).pathname;
    return decodeURIComponent(pathname.split("/").pop() || "file");
  } catch {
    return "file";
  }
};

const Comment = ({ comment }) => {
  const fileName = getFileNameFromUrl(comment);
  if (isUrl(comment)) {
    if (isFileUrl(comment)) {
      return (
        <div className={tw`flex gap-x-2 items-center`}>
          <File /> {fileName}
        </div>
      );
    } else {
      return (
        <div>
          <a href={comment} target="_blank" rel="noopener noreferrer">
            {comment}
          </a>
        </div>
      );
    }
  }

  return <div>{comment}</div>;
};

export default Comment;
